import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faTachometerAlt, faCog, faEye, faCoins, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import './Header.css';

const navConfig = {
  baseBefore: [
    {
      type: 'link',
      label: 'Dashboard',
      icon: faTachometerAlt,
      path: '/Dashboard'
    }
  ],
  baseAfter: [
    {
      type: 'link',
      label: 'Logout',
      icon: faSignOutAlt,
      path: '/',
      iconContainerClass: 'red-text'
    }
  ],
  userSpecific: {
    Admin: [
      {
        type: 'dropdown',
        label: 'System Settings',
        icon: faCog,
        id: 'systemSettingsDropdown',
        children: [
          { label: 'Register Company', path: '/CreateCompanyForm' },
          { label: 'Register Business Location', path: '/CreateBusinessLocationForm' }
        ]
      },
      {
        type: 'dropdown',
        label: 'Business Settings',
        icon: faCog,
        id: 'businessSettingsDropdown',
        children: [
          { label: 'Register Plots', path: '/UploadPlotsForm' },
          { label: 'Register Houses', path: '/UploadHousesForm' },
          { label: 'Register Users', path: '/UploadUsersForm' },
          { label: 'Register Plots Customers', path: '/UploadPlotsCustomersForm' },
          { label: 'Register Tenants', path: '/UploadTenantsForm' },
          { label: 'Create Expenses', path: '/CreateExpenseForm' },
          { label: 'Register Rentals Expense', path: '/UploadRentalsExpenseForm' },
          { label: 'Register Plots Expense', path: '/UploadPlotsExpenseForm' }
        ]
      },
      {
        type: 'dropdown',
        label: 'System Reports',
        icon: faEye,
        id: 'systemReportsDropdown',
        children: [
          { label: 'View Plots', path: '/ViewPlots' },
          { label: 'View Houses', path: '/ViewHouses' },
          { label: 'View Plot Customers', path: '/PlotsCustomers' },
          { label: 'View Sold And Unsold Plots', path: '/ViewSoldAndUnsoldPlots' },
          { label: 'View Users', path: '', hidden: true }
        ]
      },
      {
        type: 'dropdown',
        label: 'Clients Statements',
        icon: faEye,
        id: 'businessReportsDropdown',
        children: [
          { label: 'House Tenants Statements', path: '/ViewTenants' },
          { label: 'Plot Customers Statements', path: '/ViewPlotsCustomers' },
          { label: 'View UptoDate Plot Customers', path: '/ViewPlotsCustomersUptodatePayers' },
          { label: 'View Late Plot Customers', path: '/ViewPlotsCustomersLatePayers' },
          { label: 'View Customers Paid In Full', path: '/ViewPlotsCustomersCompletedPayers' },
          { label: 'NHEF', path: '/ViewPlotsCustomersNHEF' }
        ]
      },
      {
        type: 'dropdown',
        label: 'Pay For Client',
        icon: faCoins,
        id: 'makePaymentsDropdown',
        children: [
          { label: 'Pay For Plot', path: '/MakePaymentForClientPlotsForm' },
          { label: 'Pay Rentals', path: '/MakePaymentForClientRentalsForm' }
        ]
      }
    ],

    Employee: [
        {
          type: 'dropdown',
          label: 'Business Settings',
          icon: faCog,
          id: 'businessSettingsDropdown',
          children: [
            { label: 'Register Plots', path: '/UploadPlotsForm' },
            { label: 'Register Houses', path: '/UploadHousesForm' },
            { label: 'Register Users', path: '/UploadUsersForm' },
            { label: 'Register Plots Customers', path: '/UploadPlotsCustomersForm' },
            { label: 'Register Tenants', path: '/UploadTenantsForm' },
            { label: 'Create Expenses', path: '/CreateExpenseForm' },
            { label: 'Register Rentals Expense', path: '/UploadRentalsExpenseForm' },
            { label: 'Register Plots Expense', path: '/UploadPlotsExpenseForm' }
          ]
        },
        {
          type: 'dropdown',
          label: 'System Reports',
          icon: faEye,
          id: 'systemReportsDropdown',
          children: [
            { label: 'View Plots', path: '/ViewPlots' },
            { label: 'View Houses', path: '/ViewHouses' },
            { label: 'View Plot Customers', path: '/PlotsCustomers' },
            { label: 'View Sold And Unsold Plots', path: '/ViewSoldAndUnsoldPlots' },
            { label: 'View Users', path: '', hidden: true }
          ]
        },
        {
          type: 'dropdown',
          label: 'Clients Statements',
          icon: faEye,
          id: 'businessReportsDropdown',
          children: [
            { label: 'House Tenants Statements', path: '/ViewTenants' },
            { label: 'Plot Customers Statements', path: '/ViewPlotsCustomers' },
            { label: 'View UptoDate Plot Customers', path: '/ViewPlotsCustomersUptodatePayers' },
            { label: 'View Late Plot Customers', path: '/ViewPlotsCustomersLatePayers' },
            { label: 'View Customers Paid In Full', path: '/ViewPlotsCustomersCompletedPayers' },
            { label: 'NHEF', path: '/ViewPlotsCustomersNHEF' }
          ]
        },
        {
          type: 'dropdown',
          label: 'Pay For Client',
          icon: faCoins,
          id: 'makePaymentsDropdown',
          children: [
            { label: 'Pay For Plot', path: '/MakePaymentForClientPlotsForm' },
            { label: 'Pay Rentals', path: '/MakePaymentForClientRentalsForm' }
          ]
        }
      ],

    Cashier : [
        {
            type: 'dropdown',
            label: 'Pay For Client',
            icon: faCoins,
            id: 'makePaymentsDropdown',
            children: [
              { label: 'Pay For Plot', path: '/MakePaymentForClientPlotsForm' },
              { label: 'Pay Rentals', path: '/MakePaymentForClientRentalsForm' }
            ]
          }
    ],
    Site_Manager : [
      {
          type: 'dropdown',
          label: 'View Reports',
          icon: faEye,
          id: 'ViewReportsdeveloper',
          children: [
            { label: 'View Sold And Unsold Plots', path: '/ViewSoldAndUnsoldPlots' }
          ]
        }
  ],
    Customer: [],
    Tenant: []
  }
};

const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const userType = localStorage.getItem('userType') || 'default';
  const userLinks = navConfig.userSpecific[userType] || [];

  //console.log("userType Gotten : ", userType);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const renderNavItem = (item, index) => {
    if (item.type === 'link') {
      return (
        <li key={index} className="nav-item">
          <Link className={`nav-link ${item.className || ''}`} to={item.path}>
            {item.icon && (
              <span className={item.iconContainerClass || ''}>
                <FontAwesomeIcon icon={item.icon} />
              </span>
            )}
            {item.label}
          </Link>
        </li>
      );
    }
    
    if (item.type === 'dropdown') {
      return (
        <li key={index} className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle"
            to=""
            id={item.id}
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {item.icon && <FontAwesomeIcon icon={item.icon} />} {item.label}
          </Link>
          <div className="dropdown-menu" aria-labelledby={item.id}>
            {item.children.map((child, childIndex) => (
              !child.hidden && (
                <Link
                  key={childIndex}
                  className="dropdown-item"
                  to={child.path}
                >
                  {child.label}
                </Link>
              )
            ))}
          </div>
        </li>
      );
    }
    
    return null;
  };

  return (
    <div className="dashboard">
      <nav id="navbar" className="navbar navbar-expand-lg navbar-light bg-white fixed-top">
        <div className="navbar-brand">Real Estate</div>
        <button className="navbar-toggler" type="button" onClick={toggleMobileMenu}>
          <span className="navbar-toggler-icon">
            {showMobileMenu ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
          </span>
        </button>
        <div className={`collapse navbar-collapse ${showMobileMenu ? 'show' : ''}`}>
          <ul className="navbar-nav mr-auto">
            {navConfig.baseBefore.map((item, index) => renderNavItem(item, index))}
            {userLinks.map((item, index) => renderNavItem(item, index))}
            {navConfig.baseAfter.map((item, index) => renderNavItem(item, index))}
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Header;